<template>
  <div id="contenedor-clientes-toolbar">
    <v-toolbar
    flat
    dense>
    <div
      style="width: 350px"
      class="mr-2">
      <custom-text-field
        label="Buscar..."
        append-icon="mdi-magnify"
        clearable
        @keyup="buscar"
        @click:clear="limpiarBuscadorTexto">
      </custom-text-field>
    </div>
    <!-- <filtros></filtros> -->
    <v-spacer></v-spacer>
    <custom-button
      v-if="mixValidaScopesActions(1)"
      label="Nuevo"
      iconText="mdi-plus"
      tipo="agregar"
      @click="nuevo">
    </custom-button>
  </v-toolbar>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';

export default {
  name: 'ToolBarClientes',
  components: {
    CustomButton,
    CustomTextField,
  },
  data() {
    return {
      buscarTexto: null,
      debounce: null,
    };
  },
  methods: {
    buscar(e) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.buscarTexto = e.target.value;
      }, 600);
    },
    limpiarBuscadorTexto() {
      this.buscarTexto = '';
    },
    nuevo() {
      this.$emit('nuevoCliente');
    },
  },
  watch: {
    buscarTexto: {
      handler() {
        this.$emit('buscar', this.buscarTexto);
      },
    },
  },
};
</script>

<style lang="scss">

</style>
